"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDebounceWithLoading = void 0;
var react_1 = __importDefault(require("react"));
function useDebounceWithLoading(value, delay) {
    var _a = react_1.default.useState(value), debouncedValue = _a[0], setDebouncedValue = _a[1];
    var _b = react_1.default.useState(false), forcedUpdate = _b[0], setForcedUpdate = _b[1];
    react_1.default.useEffect(function () {
        // We want to make sure we don't lock in a value when its still loading. This will allow us to force the update once loading is finished.
        if (!forcedUpdate && !value.loading) {
            setDebouncedValue(value);
            setForcedUpdate(true);
        }
        // We also want to ensure that once timer has ran out we don't accidentally re lock in a value while loading is true
        if (forcedUpdate && value.loading) {
            setForcedUpdate(false);
        }
        // Update debounced value after delay
        var handler = setTimeout(function () { return setDebouncedValue(value); }, delay);
        return function () { return clearTimeout(handler); }; // This ensures that the timeout is canceled upon unmount
    }, [value, delay, forcedUpdate]); // Only re-call effect if value, delay, or forcedUpdate change
    return debouncedValue;
}
exports.useDebounceWithLoading = useDebounceWithLoading;
//# sourceMappingURL=useDebounceWithLoading.js.map